import MojitoServices from 'mojito/services';

import {md5} from '#core/utils/md5.js';

const AbstractAnalyticsService = MojitoServices.Analytics.AbstractAnalyticsService;

export class ConnextraAnalyticsService extends AbstractAnalyticsService {
    constructor(config) {
        super('connextra');
        this.iframeId = 'dbx-connextra-proxy';
        this.clientId = config.clientId;
        this.salt = config.salt;
    }

    logEvent(pageType) {
        let iframe = document.getElementById(this.iframeId);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.width = 1;
            iframe.style.height = 1;
            document.body.appendChild(iframe);
        }

        const clientId = encodeURIComponent(this.clientId);
        pageType = encodeURIComponent(pageType);

        let src = `/connextra-frame.html?clientId=${clientId}&pageType=${pageType}`;
        if (this.username) src = src + `&AccountID=${this.username}`;
        iframe.src = src;
    }

    setUsername(user) {
        this.username = md5(this.salt + user);
    }

    loggedIn() {
        this.logEvent(`loggedin`);
    }

    loggedOut() {
        this.username = ''; // do not hash username
    }

    betPlaced() {
        this.logEvent(`betconfirm`);
    }
}
